import { render, staticRenderFns } from "./ConventionDetail.vue?vue&type=template&id=2a916754&scoped=true&"
import script from "./ConventionDetail.vue?vue&type=script&lang=js&"
export * from "./ConventionDetail.vue?vue&type=script&lang=js&"
import style0 from "./ConventionDetail.vue?vue&type=style&index=0&id=2a916754&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a916754",
  null
  
)

export default component.exports